export const sideMenuSelector = {
  buttons: {
    logout: "sideMenu-logout-button",
    login: "sideMenu-login-button",
  },
};
